import BuyLottery from "../../Pages/User/buy-lottery/index";

export default BuyLottery;

